<template>
  <div>
    <div class="searchBox">
      <div class="web">
        <search ref="search" @getList="getList" plac="搜索简历" :go="false" />

        <!-- 省市区 -->
        <div class="province">
          <span
            v-for="(item, index) in provinceList"
            :key="index"
            class="provinceBox"
            :class="item.active?'areaActive':''"
            @click="provinceClick(item,index)"
          >{{item.region_name}}</span>
        </div>
        <div class="city" v-if="cityList.length > 0">
          <span
            v-for="(item, index) in cityList"
            :key="index"
            class="provinceBox"
            :class="item.active?'areaActive':''"
            @click="cityClick(item,index)"
          >{{item.region_name}}</span>
        </div>
        <div class="city" v-if="distList.length > 0">
          <span
            v-for="(item, index) in distList"
            :key="index"
            class="provinceBox"
            :class="item.active?'areaActive':''"
            @click="distClick(item,index)"
          >{{item.region_name}}</span>
        </div>

        <!-- 筛选 -->
        <div class="screen">
          <el-row :gutter="10">
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="sortClick">
                <span class="el-dropdown-link">
                  {{sortList.filter(o=>o.active === searchForm.sort)[0].name}}
                  <i
                    class="el-icon-arrow-down el-icon--right"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in sortList"
                    :key="index"
                    :command="item.active"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="workClick">
                <span class="el-dropdown-link">
                  {{searchForm.require.worktime?searchForm.require.worktime:'工作经验'}}
                  <i
                    class="el-icon-arrow-down el-icon--right"
                  ></i>
                  <i class="el-icon-circle-close" v-if="searchForm.require.worktime" @click="delSearchs('worktime')"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in workList"
                    :key="index"
                    :command="item"
                  >{{item}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="jobClick">
                <span class="el-dropdown-link">
                  {{searchForm.require.desired_position?searchForm.require.desired_position:'意向职位'}}
                  <i
                    class="el-icon-arrow-down el-icon--right"
                  ></i>
                  <i class="el-icon-circle-close" v-if="searchForm.require.desired_position" @click="delSearchs('desired_position')"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="height: 200px;overflow: auto;">
                  <el-dropdown-item
                    v-for="(item, index) in jobNameList"
                    :key="index"
                    :command="item"
                  >{{item}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="eduClick">
                <span class="el-dropdown-link">
                  {{searchForm.require.education?searchForm.require.education:'学历'}}
                  <i
                    class="el-icon-arrow-down el-icon--right"
                  ></i>
                  <i class="el-icon-circle-close" v-if="searchForm.require.education" @click="delSearchs('education')"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in eduList"
                    :key="index"
                    :command="item"
                  >{{item}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
            <el-col :span="3" class="screenBox">
              <el-dropdown @command="memberClick">
                <span class="el-dropdown-link">
                  {{searchForm.require.members_state?memberList.filter(o=>o.active === searchForm.require.members_state)[0].name:'求职状态'}}
                  <i
                    class="el-icon-arrow-down el-icon--right"
                  ></i>
                  <i class="el-icon-circle-close" v-if="searchForm.require.members_state" @click="delSearchs('members_state')"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in memberList"
                    :key="index"
                    :command="item.active"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
            <el-button type="text" class="reset" @click="resetSearch">清空筛选条件</el-button>
          </el-row>
        </div>
      </div>
    </div>

    <div class="web list" v-loading="loading">
      <div class="listBox" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
        <div class="listTop clearfix">
          <div class="listTopBox fl">
            <div>
              <el-avatar :size="64" :src="item.avatar"></el-avatar>
            </div>
            <div class="listContent">
              <div class="vita_name">{{item.vita_name}}
                <span v-if='searchForm.area.city_id === 231' class="activeTime">{{item.active_time}}</span>
              </div>
              <div class="listContentBox">
                <span>{{item.province_name?item.province_name:''}}{{item.city_name?item.city_name:''}}{{item.dist_name?item.dist_name:''}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.worktime}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.education}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.desired_position}}</span>
              </div>
            </div>
          </div>
          <div class="fr ideamoney">{{item.ideamoney}}{{item.ideamoney === '面议'?'':'元/月'}}</div>
          <div class="fr" style="margin-top: 24px;margin-right: 20px;">
            <el-link type="primary" icon="el-icon-phone-outline" @click="$event.stopPropagation();callPhone(item)">打电话</el-link>
          </div>
          <div class="fr" style="margin-top: 24px;margin-right: 20px;">
            <el-link type="primary" icon="el-icon-chat-line-round" @click="$event.stopPropagation();goChat(item)">发消息</el-link>
          </div>
        </div>
        <div class="listBottom">
            <span v-if="item.job_confim"><el-tag type="success" v-for="(labelItem, labelIndex) in item.job_confim" :key="labelIndex">{{labelItem}}</el-tag></span>
            <span v-if="item.selftags">
              <el-tag v-for="(labelItem, labelIndexs) in item.selftags" :key="labelIndexs">{{labelItem}}</el-tag>
            </span>
        </div>
      </div>
      <page :total="total" @getList="getList" />
    </div>

    <!-- 打电话 -->
    <el-dialog
      title="打电话"
      :visible.sync="callModal"
      width="30%"
      :before-close="callPhone">
      <img :src="weChatCode" style="width: 100%;" alt="">
    </el-dialog>
  </div>
</template>

<script>
import search from "@/components/search";
import page from "@/components/page";
import region from "@/js/publicJson";
import { getWeChatCode } from '@/js/common.js'

export default {
  data() {
    return {
      callModal: false,
      weChatCode: '',
      loading: true,
      provinceList: region.region,
      cityList: [],
      distList: [],
      //   排序
      sortList: [
        {
          active: "active",
          name: "活跃"
        },
        {
          active: "newest",
          name: "最新"
        },
        {
          active: "chat_reply_rate",
          name: "近90天回复率"
        }
      ],
      total: 0,
      searchForm: {
        page: 1,
        size: 10,
        sort: "active",
        require: {
          worktime: "",
          desired_position: "",
          education: "",
          members_state: ""
        },
        area: {}
      },

      //   工作经验
      workList: [
        "无经验",
        "1年以内",
        "1-2年",
        "2-4年",
        "4-6年",
        "6-10年",
        "10年以上"
      ],

      //   意向职位
      jobNameList: [
        "主班老师",
        "乐高老师",
        "书法老师",
        "亲子老师",
        "体育老师",
        "作文老师",
        "保健医生",
        "保安",
        "保教主任",
        "保洁",
        "保育员",
        "创客老师",
        "副园长",
        "副班老师",
        "厨师",
        "司机",
        "后勤主任",
        "园长",
        "园长助理",
        "外教老师",
        "实习生",
        "家庭教育老师",
        "幼教老师",
        "感统老师",
        "托育老师",
        "拼音老师",
        "教学主任",
        "数学老师",
        "早教老师",
        "校长",
        "测评师",
        "生活老师",
        "编程老师",
        "美术老师",
        "自定义",
        "舞蹈老师",
        "英语老师",
        "蒙氏老师",
        "行政老师",
        "课程营销",
        "课程顾问",
        "速算导师",
        "钢琴老师",
        "音乐老师"
      ],

      // 学历
      eduList: ["不限", "中专", "初中", "大专", "本科", "本科以上", "高中"],

      //   求职状态
      memberList: [
        {
          active: "0",
          name: "离职-立即上岗"
        },
        {
          active: "1",
          name: "在职-月内上岗"
        },
        {
          active: "2",
          name: "在职-考虑机会"
        },
        {
          active: "3",
          name: "在职不考虑机会"
        }
      ],

      //   列表
      list: []
    };
  },
  components: {
    search,
    page
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 打电话
    callPhone(o) {
      this.callModal = !this.callModal
      getWeChatCode(this, 'bossjoin/pages/BossResumeDetail/BossResumeDetail', 'vid=' + o.vid)
    },

    // 发消息
    goChat(o) {
      this.api.get('/5cef405d39ad5', { page: 1, size: 8 }).then(r => {
        if(r.data.list.length > 0 ) {
          if(r.data.list[0].status === 1) {
            this.$router.push({
              path: '/chat',
              query: {
                vid: o.vid
              }
            })
          } else {
            this.$message({
              message: '请先发布职位或开启职位',
              type: 'success'
            });
            this.$router.push({ path: '/boss/post' })
          }
        }
      })
    },

    // 删除搜索
    delSearch(d) {
      this.searchForm.condition[d] = ''
      this.getList()
    },

    // 删除搜索
    delSearchs(d) {
      this.searchForm.require[d] = ''
      this.getList()
    },

    // 获取列表
    getList(page, keyWord) {
      this.loading = true
      if(page) {
        this.searchForm.page = page
      } else {
        this.searchForm.page = 1
      }
      if(keyWord) {
        this.searchForm.keywords = keyWord
      }
      this.api.post('/5cf3c840eaa68', this.searchForm).then(r => {
        this.loading = false
        this.list = r.data.list
        this.total = r.data.count
        this.list.forEach(o=>{
          if(o.job_confim) {
            o.job_confim = JSON.parse(o.job_confim)
          }
          if(o.selftags) {
            o.selftags = JSON.parse(o.selftags)
          }

          if(this.searchForm.area.city_id === 231) {
            var nowTimer=Date.parse(new Date())/1000;//获系统时间戳
            for(let i=0;i<this.list.length;i++){
              let active_time=this.list[i].active_time;
              let dTime=Math.floor((nowTimer-active_time)/3600);
              switch(dTime){
                case 0:{
                  this.list[i].active_time = '刚刚活跃'
      
                  if(active_time[i]=='刚刚活跃'){
                  }
                  break
                };
                default:{
                  if(dTime>0&&dTime<24){
                    this.list[i].active_time = dTime+"小时前活跃"
                  }
                  else{
                    let dDay=Math.floor(dTime/24);
                    if(dDay>0&&dDay<30){
                      this.list[i].active_time = dDay+"天前活跃"
                    }
                    else if(dDay > 30 && dDay <= 60){
                      this.list[i].active_time = '1月前活跃'
                    }else if(dDay > 60 && dDay <= 90){
                      this.list[i].active_time = '2月前活跃'
                    }else if(dDay > 90 && dDay <= 180) {
                      this.list[i].active_time = '半年前活跃'
                    } else if(dDay >180) {
                      this.list[i].active_time = '1年前活跃'
                    }
                  }
                }
              }
            }
          }
        })
      })
    },

    //   省点击
    provinceClick(o, i) {
      this.cityList = o.children;
      this.provinceList.forEach(o => {
        o.active = false;
      });
      o.active = true;
      this.searchForm.area.province_id = o.region_id
      this.searchForm.area.provice_name = o.region_name
      this.searchForm.area.city_id = ''
      this.searchForm.area.city_name = ''
      this.searchForm.area.dist_id = ''
      this.searchForm.area.dist_name = ''
      this.distList = []
      this.getList()
    },

    //   市点击
    cityClick(o, i) {
      this.distList = o.children;
      this.cityList.forEach(o => {
        o.active = false;
      });
      o.active = true;
      this.searchForm.area.city_id = o.region_id
      this.searchForm.area.city_name = o.region_name
      this.searchForm.area.dist_id = ''
      this.searchForm.area.dist_name = ''
      this.getList()
    },

    // 区点击
    distClick(o, i) {
      this.distList.forEach(o => {
        o.active = false;
      });
      o.active = true;
      this.distList = JSON.parse(JSON.stringify(this.distList));
      this.searchForm.area.dist_id = o.region_id
      this.searchForm.area.dist_name = o.region_name
      this.getList()
    },

    // 排序筛选
    sortClick(e) {
      this.searchForm.sort = e;
      this.getList()
    },

    // 工作经验点击
    workClick(e) {
      this.searchForm.require.worktime = e;
      this.getList()
    },

    // 意向职位
    jobClick(e) {
      this.searchForm.require.desired_position = e;
      this.getList()
    },

    // 学历点击
    eduClick(e) {
      this.searchForm.require.education = e;
      this.getList()
    },

    // 求职状态
    memberClick(e) {
      this.searchForm.require.members_state = e;
      this.getList()
    },

    // 清空筛选
    resetSearch() {
      this.searchForm = {
        area: this.searchForm.area,
        sort: "active",
        keywords: '',
        require: {
          worktime: "",
          desired_position: "",
          education: "",
          members_state: ""
        }
      };
      this.$refs.search.searchVal = ''
      this.getList()
    },

    // 简历详情
    goDetail(e) {
      let routeData = this.$router.resolve({
        path: '/boss/resumeDetail',
        query: {
          vid: e.vid?e.vid:''
        },
      })
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.searchBox {
  padding-top: 32px;
  background: #fff;
  box-shadow: 0 3px 6px rgba(6, 0, 1, 0.05);
  .provinceBox {
    padding: 0 11px;
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
    margin-top: 10px;
  }
  .province {
    padding-bottom: 10px;
  }
  .areaActive {
    color: #ff5b12;
  }
  .city {
    border-top: 1px solid #eef0f5;
    padding-bottom: 10px;
  }
  .screen {
    border-top: 1px solid #eef0f5;
    padding: 10px 0;
    position: relative;
    .screenBox {
      text-align: center;
      .el-dropdown-link {
        cursor: pointer;
      }
    }
    .reset {
      position: absolute;
      right: -86px;
      top: -10px;
    }
  }
}

.list {
  padding-top: 20px;
  .listBox {
    background: white;
    margin-top: 20px;
    cursor: pointer;
  }
  .listBox:hover {
    .vita_name {
      color: #fc703e;
    }
  }
  .listBox:first-child {
    margin-top: 0;
  }
  .listTop {
    padding: 20px 30px;
    .listTopBox {
      > div {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .listContent {
      margin-left: 5px;
      .listContentBox {
        padding-top: 5px;
        font-size: 14px;
        color: #61687c;
      }
    }
  }
  .ideamoney {
    color: #fc703e;
    line-height: 68px;
  }
  .listBottom {
      padding: 0 20px;
      padding-bottom: 10px;
      font-size: 0;
      padding-left: 102px;
      span {
        font-size: 14px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
  }
}

.activeTime {
  color: #ff5b12;
  font-size: 12px;
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/boss/resume.vue